'use strict';

const frontPage = 'timeline';

class DynamicUrls {
  get baseUrl() {
    return this._baseUrl;
  }
  set baseUrl(baseUrl) {
    this._baseUrl = baseUrl;
  }
  get apiUrl() {
    return this._apiUrl;
  }
  set apiUrl(apiUrl) {
    this._apiUrl = apiUrl;
  }
  get logoutRedirectUrl() {
    return this._logoutRedirectUrl;
  }
  set logoutRedirectUrl(logoutRedirectUrl) {
    this._logoutRedirectUrl = logoutRedirectUrl;
  }
  get medixineApiUrl() {
    return this._medixineApiUrl;
  }
  set medixineApiUrl(medixineApiUrl) {
    this._medixineApiUrl = medixineApiUrl;
  }
  get logoutFallbackUrl() {
    return this._logoutFallbackUrl;
  }
  set logoutFallbackUrl(logoutFallbackUrl) {
    this._logoutFallbackUrl = logoutFallbackUrl;
  }
  set omavointiRedirectUrl(omavointiRedirectUrl) {
    this._omavointiRedirectUrl = omavointiRedirectUrl;
  }
  get omavointiRedirectUrl() {
    return this._omavointiRedirectUrl;
  }
  set gtiTargetUrl(gtiTargetUrl) {
    this._gtiTargetUrl = gtiTargetUrl;
  }
  get gtiTargetUrl() {
    return this._gtiTargetUrl;
  }
}

let dynamicUrls = new DynamicUrls();

export default {
  setLogoutRedirectUrl: (logoutRedirectUrl) => {
    dynamicUrls.logoutRedirectUrl = logoutRedirectUrl;
  },
  setMedixineApiUrl: (medixineApiUrl) => {
    dynamicUrls.medixineApiUrl = medixineApiUrl;
  },
  setBaseUrl: (baseUrl) => {
    dynamicUrls.baseUrl = baseUrl;
  },
  setApiUrl: (apiUrl) => {
    dynamicUrls.apiUrl = apiUrl;
  },
  setLogoutFallbackUrl: (logoutFallbackUrl) => {
    dynamicUrls.logoutFallbackUrl = logoutFallbackUrl;
  },
  setOmavointiRedirectUrl: (omavointiRedirectUrl) => {
    dynamicUrls.omavointiRedirectUrl = omavointiRedirectUrl;
  },
  setGtiTargetUrl: (gtiTargetUrl) => {
    dynamicUrls.gtiTargetUrl = gtiTargetUrl;
  },
  baseUrl: () => dynamicUrls.baseUrl,
  apiUrl: () => dynamicUrls.apiUrl,
  // frontpage has versions for using href and react router api
  frontPage: '#/' + frontPage,
  frontPageHistory: '/' + frontPage,
  logout: () => '/api/apiLogout',
  logoutFallback: () => dynamicUrls.logoutFallbackUrl,
  logoutFallbackRedirect: () => dynamicUrls.logoutRedirectUrl,
  timelineFeedback:
    'https://asiakaspalaute.pirha.fi/qa/QADataEntry.aspx?Q=00400127290&CV9=1&CV1=85&CV2=854&CV3=8543&CV4=85432&CV5=955&CT5=S%C3%A4hk%C3%B6inen+asiointi%3b+Oma+Tays-palvelu',
  timelineNoticeOfDefect:
    'https://q.surveypal.com/OmaTays-vikailmoitus-v2',
  timelineTreatmentFeedback:
    'https://asiakaspalaute.pirha.fi/AnalysticaStart/Pirha.aspx',
  omaKanta: 'https://kansalainen.kanta.fi/?lg=fi',
  patientFees:
    'http://www.pshp.fi/fi-FI/Ohjeet/Potilaana_Taysissa/Asiakasmaksut',
  careUnitdetails:
    'http://www.pshp.fi/fi-FI/Toimipaikat/Tays_Keskussairaala/Hoitoyksikot/Munuaispoliklinikka',
  registerDescription: 'https://pirha.fi/tietosuoja/sahkoinen-asiointi',

  gtiRedirect: '/api/gtiredirect',
  gtiDetails:
    'https://www.pirha.fi/fi/toimipisteet/toimipistehakemisto/reumakeskus-tays-keskussairaala',

  fimlabAppointment: 'https://www.fimlab.fi/sivu.tmpl?sivu_id=185',
  fimlabLaboratories:
    'https://www.fimlab.fi/toimipisteet/toimipisteluettelo.tmpl?sivu_id=142',

  medixineApi: () => dynamicUrls.medixineApiUrl,

  omavointiRedirectUrl: () => dynamicUrls.omavointiRedirectUrl,

  gtiTargetUrl: () => dynamicUrls.gtiTargetUrl,
};
